import api from './axios';
import { isPrivateProviderContext, privateManagementList, privateManagementRequest, providerPayload } from './private-provider-management';

const providesRequests = {
    getAllProvider(){
        return isPrivateProviderContext() ? privateManagementList('providers') : api.get('/provider')
    },
    saveProvider(form){
        return isPrivateProviderContext() ? privateManagementRequest('post', 'providers', providerPayload(form)) : api.post('/provider',form)
    },
    updateProvider(id,form){
        return isPrivateProviderContext() ? privateManagementRequest('patch', `providers/${id}`, providerPayload(form, true)) : api.patch(`/provider/${id}`,form)
    }
};

export default providesRequests;
